export default "__VITE_ASSET__e9671578__"